<template>
	<div class="video-player" @click="player_opened=!player_opened">
		<div class="preview" :style="{backgroundImage:`url(https://img.youtube.com/vi/${value.src}/0.jpg)`}">
			<div class="fader">
				<div class='play-btn'>
					<img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAJCAQAAACRI2S5AAAAEElEQVR42mNkIAAYRxWAAQAG9gAKqv6+AwAAAABJRU5ErkJggg==">
				</div>
			</div>
		</div>
		<div class="player-backdrop" v-if="player_opened" >
			<div class="player-window" :style="{backgroundImage:`url(https://img.youtube.com/vi/${value.src}/0.jpg)`}">
				<div class="exit-btn">
					<div class="fa fa-times"></div>
				</div>
				<i-loader/>
				<iframe width="854" height="480" :src="'https://www.youtube.com/embed/'+value.src+'?autoplay=true'" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
			</div>
		</div>
	</div>
</template>

<script>
import iLoader from "./i-loader.vue";
export default {
  name: 'i-video',
  components:{iLoader},
  props:["width", "height","preview","value"],
  data () {
    return {
    	player_opened:false
    }
  }
}
</script>

<style lang="css" scoped>
.play-btn{
	font-size: 42px;
    color: white;
}
.video-player:hover .play-btn{
    
	
}
.video-player{
	display: inline-block;
	background: black;
	width:100%;
	/*outline: 1px solid red;*/
	cursor: pointer;

}

table td{
	vertical-align: middle;
	text-align: center;
	 padding: 0;
}

.preview{
	width:100%;
	height: 100%;
	background-size: cover;
	background-position: center;
}
.video-player .fader{
	background-color: rgba(0,0,0,0.5);
	transition: .3s all ease;
}
.video-player:hover .fader{
	background-color: rgba(0,0,0,0.2);
}
.video-player img{
	width:100%;
}

.player-backdrop{
	width:100%;
	height:100%;
	position: fixed;
	z-index:13;
	background-color: rgba(0,0,0,0.9);
	top:0;
	left:0;
	z-index: 1006;
}
.player-window{
	width:854px;
	height:480px;
	margin-left:-427px;
	margin-top:-240px;
	top:50%;
	left:50%;
	position: absolute;
	background-size: cover;
	background-position: center;
}


.play-btn{
	font-size: 0;
	background-repeat: no-repeat;
	background-size: 48px 48px;
	background-position: center;
	background-image: url(data:image/svg+xml;utf8;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQxLjk5OSA0MS45OTkiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQxLjk5OSA0MS45OTk7IiB4bWw6c3BhY2U9InByZXNlcnZlIiB3aWR0aD0iMTI4cHgiIGhlaWdodD0iMTI4cHgiPgo8cGF0aCBkPSJNMzYuMDY4LDIwLjE3NmwtMjktMjBDNi43NjEtMC4wMzUsNi4zNjMtMC4wNTcsNi4wMzUsMC4xMTRDNS43MDYsMC4yODcsNS41LDAuNjI3LDUuNSwwLjk5OXY0MCAgYzAsMC4zNzIsMC4yMDYsMC43MTMsMC41MzUsMC44ODZjMC4xNDYsMC4wNzYsMC4zMDYsMC4xMTQsMC40NjUsMC4xMTRjMC4xOTksMCwwLjM5Ny0wLjA2LDAuNTY4LTAuMTc3bDI5LTIwICBjMC4yNzEtMC4xODcsMC40MzItMC40OTQsMC40MzItMC44MjNTMzYuMzM4LDIwLjM2MywzNi4wNjgsMjAuMTc2eiIgZmlsbD0iI0ZGRkZGRiIvPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8Zz4KPC9nPgo8L3N2Zz4K);
}

iframe{
	position: relative;
	z-index: 15;

}

.exit-btn{
	color:white;
	position: absolute;
	margin-top:-32px;
	font-size:26px;
	right:-26px;
}

@media(max-width:920px){
	.player-backdrop .player-window{
		width:100%;
		left:0;
		top:0;
		margin: 0;
		top:100px;
	}
	.exit-btn{
		right: 13px;
	    font-size: 64px;
    	margin-top: -64px;
	}
	iframe{
		width: 100%;
	}
}
</style>